import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAllPurchaseOrders = async () => {
  try {
    const response = await apiClient.get(
      '/systemInvoiceManagement/purchaseOrderManagement/authorized-records'
    );

    // Handle the response structure: { status, message, response }
    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }

    // Fallback to direct data if structure is different
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
